<template>
	<div class="main p34">
		<div class="my-title">{{ info.productName }}</div>
		<div class="recognize-table mt10">
			<span v-if="fiveRisk" class="errorMsg">5类人员占比超过50%，<b>新增人员</b>保费上浮20%，上浮保费已标红色。</span>
			<Row type="flex" justify="space-between">
				<Col span="12">
					<Button type="info" @click="add">添加人员</Button>
					<Button type="info" @click="batch">批量保全</Button>
				</Col>
				<Col span="12" style="text-align: right;">
					<Input v-model="number" clearable placeholder="请输入姓名" style="width:200px"></Input>
					<Button type="primary" @click="search">搜索</Button>
				</Col>
			</Row>
			<el-table class="mt10" :data="orderData" border style="width: 100%">
				<el-table-column fixed prop="insuredPersonName" label="姓名" width="100"></el-table-column>
				<el-table-column prop="idCard" label="证件号码" width="190"></el-table-column>
				<el-table-column prop="gender" label="性别" width="70"></el-table-column>
				<el-table-column prop="age" label="年龄" width="70"></el-table-column>
				<el-table-column prop="jobTypeName" label="职业/工种" show-overflow-tooltip width="150"></el-table-column>
				<el-table-column prop="schemeName" label="保障方案" show-overflow-tooltip width="150"></el-table-column>
				<el-table-column prop="companyNameFrom" label="派遣单位" show-overflow-tooltip width="150"></el-table-column>
				<el-table-column prop="companyNameTo" label="实际用工单位" show-overflow-tooltip width="150"></el-table-column>
				<el-table-column prop="desc" label="工作描述" show-overflow-tooltip width="150"></el-table-column>
				<el-table-column prop="province" label="用工省" show-overflow-tooltip width="150"></el-table-column>
				<el-table-column prop="city" label="用工市" show-overflow-tooltip width="150"></el-table-column>
				<el-table-column prop="district" label="用工区" show-overflow-tooltip width="150"></el-table-column>
				<el-table-column prop="effectiveStatusDesc" label="状态" width="120"></el-table-column>
				<el-table-column prop="effectiveDateStart" label="保障起期" width="150"></el-table-column>
				<el-table-column prop="effectiveDateEnd" label="保障止期" width="150"></el-table-column>
				<el-table-column prop="premium" label="费用" width="150">
					<template slot-scope="{ row }">
						<span :style="{ color: row.fiveRisk ? 'red' : '#333' }">{{ row.premium }}{{ row.premium == '-' ? '' : '元' }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="备注" width="150">
					<template slot-scope="{ row }">
						<span :style="{ color: row.operation == 'INIT' ? '#333' : 'red' }">{{ row.remark }}</span>
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="130">
					<template slot-scope="scope">
						<!-- 大地低职业-->
						<a v-if="scope.row.operation == 'INIT'&&info.productCode=='CCIC_EMPLOYER_LIABILITY_M2'" key="bianji" @click="openEdit(scope.row)">编辑</a>
						<a v-if="scope.row.operation == 'INIT'&&info.insurancePeriod=='3'" @click="openRelace(scope.row)">替换</a>
						<a v-if="scope.row.operation == 'ADD'" key="shanchu" @click="delList(scope.row,scope.$index)">删除</a>
						<a v-if="(scope.row.operation == 'EDIT' || scope.row.operation == 'REMOVE' || scope.row.operation == 'REPLACE')" @click="recall(scope.row, scope.$index)" key="chehui">撤回</a>
					</template>
				</el-table-column>
			</el-table>
			<Row class="mt10" v-if="orderDataRst.length>0">
				<Col :span="24" class="right">
					<el-pagination
						:current-page="pageinfo.page"
						:page-size="pageinfo.size"
						:total="pageinfo.total"
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						layout="prev, pager, next"
					>
					</el-pagination>
				</Col>
			</Row>
		</div>
		<!-- 核保中 -->
		<div v-if="endorseStatus=='REVIEWING'">
			<div class="mt10 center">
				<Button type="primary" disabled>核保中</Button>
				<div class="mt20">
					1、如您在等待过程中需关闭此页面，则该批改单可以在【用户中心-我的保全】中将批改单状态选择为“核保中”，进行查看。
					2、如核保通过，则进入【用户中心-我的订单-选择待支付订单】进行后续支付流程即可。
				</div>
			</div>
		</div>
		<!-- 待确认 核保失败 -->
		<div v-if="endorseStatus=='REVIEWED_REJECTED'">
			<p class="mt10 center" style="color: red;">
				失败原因：{{ info.remark }}
			</p>
			<div class="mt10 center">
				<a class="mt30" v-if="number" @click="returnClick">返回全部列表，进行提交</a>
				<Button v-else type="success" @click="sub" :disabled="!canSub">提交信息</Button>
			</div>
		</div>
		<div v-if="endorseStatus!='REVIEWED_REJECTED'&&endorseStatus!='REVIEWING'">
			<div class="mt10 center">
				<a class="mt30" v-if="number" @click="returnClick">返回全部列表，进行提交</a>
				<Button v-else type="success" @click="sub" :disabled="!canSub">提交信息</Button>
			</div>
		</div>
		<Modal v-model="addShow" title="添加人员信息" width="400px" :mask-closable="false" scrollable>
			<Form :model="addForm" ref="addForm" :label-width="90" :rules="addFormRules">
				<FormItem label="姓名" prop="insuredPersonName">
					<Input type="text" v-model="addForm.insuredPersonName"></Input>
				</FormItem>
				<FormItem label="证件号" prop="idCard">
					<Input type="text" v-model="addForm.idCard"></Input>
				</FormItem>
				<FormItem label="工种" prop="jobTypeCode" key="jobTypeCode">
					<SelectJob :list="jobList" :value="addForm.jobTypeCode" :productCode="info.productCode" @change="val=>jobChange(val,'addForm')"/>
					<p class="red" style="line-height: normal;margin-top:10px" v-show="textShow">请选择原保单中已有的职业类别</p>
				</FormItem>
				<FormItem label="选择方案" prop="scheme" v-if="addForm.jobTypeCode" key="caseListAll">
					<Select v-model="addForm.scheme" placeholder="请选择保障方案" @on-change="caseChange" transfer>
						<Option :value="item.scheme" v-for="(item, index) in caseListAll" :key="index">{{item.schemeName}}</Option>
					</Select>
				</FormItem>
				<FormItem label="派遣单位" prop="companyNameFrom" key="companyNameFrom">
					<Input type="text" v-model="addForm.companyNameFrom"></Input>
				</FormItem>
				<FormItem label="实际用工单位" prop="companyNameTo" key="companyNameTo">
					<Input type="text" v-model="addForm.companyNameTo"></Input>
				</FormItem>
				<FormItem label="工作描述" prop="desc" key="desc">
					<Input type="text" v-model="addForm.desc"></Input>
				</FormItem>
				<FormItem label="用工省" prop="province" key="province">
					<Input type="text" v-model="addForm.province"></Input>
				</FormItem>
				<FormItem label="用工市" prop="city" key="city">
					<Input type="text" v-model="addForm.city"></Input>
				</FormItem>
				<FormItem label="用工区" prop="district" key="district">
					<Input type="text" v-model="addForm.district"></Input>
				</FormItem>
			</Form>
			<template slot="footer">
				<Button type="text" @click="addShow = false">取消</Button>
				<Button type="primary" @click="confirmAdd">确定</Button>
			</template>
		</Modal>
		<Modal v-model="editShow" title="编辑人员信息" width="400px" :mask-closable="false" scrollable>
			<Form :model="editForm" ref="editForm" :label-width="100" :rules="editFormRules" @submit.native.prevent>
				<FormItem label="姓名" prop="insuredPersonName">
					<Input type="text" v-model="editForm.insuredPersonName"></Input>
				</FormItem>
			</Form>
			<template slot="footer">
				<Button type="text" @click="editShow = false">取消</Button>
				<Button type="primary" @click="confirmEdit">确定</Button>
			</template>
		</Modal>

		<Modal v-model="replaceShow" width="600px" title="人员替换" :mask-closable="false" scrollable>
			<Card title="原员工">
				<Form :label-width="90">
					<Row>
						<Col span="12">
						<FormItem label="姓名：" class="mb0">
							{{ replaceData.insuredPersonName }}
						</FormItem>
						</Col>
						<Col span="12">
						<FormItem label="职业工种：" class="mb0">
							{{ replaceData.jobTypeName }}
						</FormItem>
						</Col>
					</Row>
					<Row>
						<Col span="24">
						<FormItem label="证件号：" class="mb0">
							{{ replaceData.idCard }}
						</FormItem>
						</Col>
						<Col span="24">
						<FormItem label="保障方案：" class="mb0">
							{{ replaceData.schemeName }}
						</FormItem>
						</Col>
					</Row>
				</Form>
			</Card>
			<Card title="替换后员工">
				<Alert type="warning">同原员工的保障方案、职业类别必须一致才能替换</Alert>
				<Form :model="replaceForm" ref="replaceForm" :label-width="80" :rules="replaceFormRules">
					<FormItem label="姓名" prop="insuredPersonName">
						<Input type="text" v-model="replaceForm.insuredPersonName"></Input>
					</FormItem>
					<FormItem label="证件号" prop="idCard">
						<Input type="text" v-model="replaceForm.idCard"></Input>
					</FormItem>
					<FormItem label="工种" prop="jobTypeCode">
						<SelectJob :list="jobList" :value="replaceForm.jobTypeCode" :productCode="info.productCode"
							@change="val => jobChange(val, 'replaceForm')" />
					</FormItem>
					<FormItem label="派遣单位" prop="companyNameFrom">
						<Input type="text" v-model="replaceForm.companyNameFrom"></Input>
					</FormItem>
					<FormItem label="实际用工单位" prop="companyNameTo">
						<Input type="text" v-model="replaceForm.companyNameTo"></Input>
					</FormItem>
					<FormItem label="工作描述" prop="desc">
						<Input type="text" v-model="replaceForm.desc"></Input>
					</FormItem>
					<FormItem label="用工省" prop="province">
						<Input type="text" v-model="replaceForm.province"></Input>
					</FormItem>
					<FormItem label="用工市" prop="city">
						<Input type="text" v-model="replaceForm.city"></Input>
					</FormItem>
					<FormItem label="用工区" prop="district">
						<Input type="text" v-model="replaceForm.district"></Input>
					</FormItem>
				</Form>
			</Card>

			<template slot="footer">
				<Button type="text" @click="replaceShow = false">取消</Button>
				<Button type="primary" :loading="replaceLoading" @click="confirmReplace">确定</Button>
			</template>
		</Modal>
		<Modal v-model="confirmShow" title="人员信息变更" width="400px" :mask-closable="false" scrollable>
			<Form :label-width="100">
				<FormItem :label-width="20">
					本次编辑人员，{{ confirmForm.premium >= 0 ? '合计需缴纳' : '合计需退回' }}
					{{ Math.abs(confirmForm.premium) }}元
				</FormItem>
				<FormItem label="上传批改单：" v-if="confirmForm.premium>=0">
					<UploadFileImg 
						@on-success="val=>uploadSuccess(val)" 
						:accept="['image']"
						type="select"
						btn-text="上传批改单"></UploadFileImg>
						<div v-if="correctUrlList.length>0">
							<p v-for="(item,index) in correctUrlList" :key="index">
								批改单{{index+1}}&nbsp;&nbsp;&nbsp;<a :href="item" target="_blank" class="ml10" :key="index">查看</a>&nbsp;<a style="color:#ed4014" @click="del(index)">删除</a>
							</p>
						</div>
				</FormItem>
			</Form>
			<template slot="footer">
				<span v-if="confirmForm.premium < 0" class="edit-warning">本产品不支持退费，此次修改无效</span>
				<Button type="text" @click="confirmShow = false" v-if="confirmForm.premium < 0">关闭</Button>
				<Button type="text" @click="confirmShow = false; confirmLoading = false; correctUrlList = []" v-if="confirmForm.premium >= 0">取消</Button>
				<span>
					<Button type="primary" @click="confirmSub" 
					v-if="confirmForm.premium >= 0" :loading="confirmLoading">确定</Button>
				</span>
			</template>
		</Modal>
		<TrackNotice :companyName="this.info.subjectName" />
	</div>
</template>
<script>
import Area from './common/Area'
import UploadFileImg from './common/UploadFileImg'
import SelectJob from './common/SelectJob'
import TrackNotice from '@/components/common/TrackNotice.vue';
import track from "@/mixin/track";
import { mapState } from 'vuex'
export default {
	components: { SelectJob, UploadFileImg,TrackNotice,Area },
	mixins:[track],
	data() {
		return {
			correctUrlList: [],
			replaceLoading: false,
			info: {},
			originalList: [],// 原保单数据
			id: this.$route.params.id,
			orderData: [],
			orderDataRst:[], // 原始数据
			addShow: false,
			addForm: {},
			addFormRules: {
				insuredPersonName: { required: true, message: '请填写姓名', trigger: 'blur' },
				idCard: { required: true, message: '请填写证件号', trigger: 'blur' },
				jobTypeCode: { required: true, message: '请选择职业/工种', trigger: 'change' },
				scheme: { required: true, message: '请选择保障方案', trigger: 'change' },
				isAerial:{required:true,message:'请选择高空/非高空',trigger:'change'},
				districtCode:[{required:true,message:'请选择省市区',trigger:'change'}],
				companyNameFrom: { required: true, message: '请输入派遣单位', trigger: 'blur' },
				companyNameTo: { required: true, message: '请输入实际用工单位', trigger: 'blur' },
				desc: { required: true, message: '请输入工作描述', trigger: 'blur' },
				province: { required: true, message: '请输入用工省', trigger: 'blur' },
				city: { required: true, message: '请输入用工市', trigger: 'blur' },
				district: { required: true, message: '请输入用工区', trigger: 'blur' }
			},
			editShow: false,
			editForm: {},
			editFormRules: {
				insuredPersonName: { required: true, message: '请填写姓名', trigger: 'blur' },
			},
			replaceShow: false,
			replaceData: {},
			replaceForm: {},
			replaceFormRules: {
				insuredPersonName: { required: true, message: '请填写姓名', trigger: 'blur' },
				idCard: { required: true, message: '请填写证件号', trigger: 'blur' },
				jobTypeCode: { required: true, message: '请选择职业/工种', trigger: 'change' },
				districtCode:[{required:true,message:'请选择省市区',trigger:'change'}],
				companyNameFrom: { required: true, message: '请输入派遣单位', trigger: 'blur' },
				companyNameTo: { required: true, message: '请输入实际用工单位', trigger: 'blur' },
				desc: { required: true, message: '请输入工作描述', trigger: 'blur' },
				province: { required: true, message: '请输入用工省', trigger: 'blur' },
				city: { required: true, message: '请输入用工市', trigger: 'blur' },
				district: { required: true, message: '请输入用工区', trigger: 'blur' }
			},
			confirmShow: false,
			confirmForm: {},
			caseList: [],
			subList: [],
			correctUrl: '',
			confirmLoading: false,
			jobList: [],
			channel: '',
			isAerial:false, // 是否包含高空
			isNoAerial:false,// 是否包含非高空
			caseListAll: [],
			isReset: this.$route.query.reset || '', // reset=1重新投保
			endorseNo: this.$route.query.endorseNo || '',
			endorseStatus:'',
			timer:null,
			number:'',
			check:'1',
			radioList:[],
			textShow:false,
			loading:false,
			pageinfo: {
				page: 1,
				size: 20,
				total: 0,
			}
		}
	},
	computed: {
		canSub() {
			let list = this.orderDataRst.filter(item => {
				return item.operation != 'INIT'&&item.operation != 'REPLACED'
			})
			return list.length > 0
		},
		fiveRisk() {
			let fiveRisk = false
			this.orderDataRst.forEach(item => {
				if (item.fiveRisk) fiveRisk = true
			})
			return fiveRisk
		},
		fillist(){
			// 返回过滤后的数组
			return this.orderDataRst.filter((p)=>{
				return p.insuredPersonName.indexOf(this.number) !==-1
			})
		}
	},
	created() {
		this.getInfo();
	},
	mounted(){
		// 回溯 开始录制
		this.track_is_new = true;
		this.$nextTick(()=>{
			this.trackInit();
		})
	},
	beforeDestroy() {
		//在 beforeDestroy生命周期函数中销毁定时器
		clearInterval(this.timer);
		this.timer = null;
	},
	beforeRouteLeave (to, from, next) {
		this.confirmShow = false;
		this.$nextTick(()=>{
			next();
		})
	},
	methods: {
		areaChange(val,name){
			this[name].provinceCode=val[0].value
			this[name].province=val[0].label
			this[name].cityCode=val[1].value
			this[name].city=val[1].label
			this[name].district=val[2].label
		},
		/** 切换每页显示条数 */
		handleSizeChange(val) {
			this.pageinfo.page = 1;
			this.pageinfo.size = val;
			this.orderData = this.currentChangePage(val, this.pageinfo.page);
			this.pageinfo.total = this.orderDataRst.length;
		},
		/** 切换分页 */
		handleCurrentChange(val) {
			this.pageinfo.page = val;
			this.orderData = this.currentChangePage(this.pageinfo.size, val);
			this.pageinfo.total = this.orderDataRst.length;
		},
		// 分页方法
		currentChangePage(size, current) {
			const tablePush = [];
			let array = this.jsonCopy(this.orderDataRst);
			array.forEach((item, index) => {
				if (size * (current - 1) <= index && index <= size * current - 1) {
				tablePush.push(item);
				}
			});
			return tablePush;
		},
		// 返回列表
		returnClick(){
			this.number = '';
			this.search();
		},
		radioChange(){
			// this.addForm.jobTypeCode = '';
			// this.addForm.jobTypeName = '';
			this.$set(this.addForm,'jobTypeCode','');
			this.$set(this.addForm,'jobTypeName','');
			this.radioList = this.unique(this.orderData);
		},
		unique(arrList){
			const res = new Map();
			return arrList.filter((arr) => !res.has(arr.jobTypeCode) && res.set(arr.jobTypeCode, arr.jobTypeCode));
		},
		search(){
			if(this.number){
				this.orderData = this.fillist;
			} else {
				this.orderData = this.currentChangePage(this.pageinfo.size,this.pageinfo.page);
			}
		},
	 	async getTree() {
			await this.$axios.post('/broker/dict/items/tree.json', {
				bizId: 'INDUSTRY_ENTERPRISE',
				companyId: '10157',
				dictCode: 'work_type',
				version:  this.info.dictVersion,
				productCode: this.info.productCode,
			}).then((res) => {
				this.jobList = this.convertTree(res)
			})
		},
		convertTree(tree) {
			let list = tree.map(item => {
				return {
					...item,
					loading: false
				}
			})
			let result = JSON.parse(JSON.stringify(list).replace(/"value"/g, '"label"').replace(/"key"/g, '"value"'))
			return result
		},
		// 获取方案列表
		getCaseList(key) {
			this.$axios.post('/broker/insurance/endorse/queryUsablePlanList.json', {
				bizId: 'INDUSTRY_ENTERPRISE',
				productCode: this.info.productCode,
				insurancePolicyId: this.id,
				jobTypeCode: this.addForm.jobTypeCode
			}).then(res => {
				this.caseListAll = res;
				if(res.length>0&&key){
					this.addForm.schemeName = res[0].schemeName;
					this.addForm.scheme = res[0].scheme;
				}
				// this.info.productCode=='CCIC_EMPLOYER_LIABILITY'&&
				if(res.length==0){
					this.textShow = true
				} else {
					this.textShow = false
				}
			});
		},
		/*获取订单信息*/
		async getInfo() {
			this.loading = true;
			let obj = { insurancePolicyId: this.id }
			let res = await this.$axios.get('/broker/insurance/policy/detail.dst', obj)
			this.info = res;
			console.log('订单详情',res)
			res.subjectMatter = res.subjectMatter.map(item => {
				item.operation = 'INIT'
				return item
			})
			this.originalList = this.jsonCopy(res.subjectMatter); // 原保单数据
			let newData = [];
			if (this.isReset) {
				// 原始数据
				let plist = this.jsonCopy(res.subjectMatter)
				// 批改数据
				let eList = await this.$axios.get('/broker/insurance/endorse/detailByEndorseNo', { endorseNo: this.endorseNo })
				this.endorseStatus = eList.endorseStatus;
				this.info.remark = eList.remark;
				// 重新计算价格
				let list = await this.$axios.post('/broker/insurance/endorse/apply.json.dst', {
					insurancePolicyId: this.id,
					subjectMatter: eList.subjectMatter
				}).catch(err=>{
					this.loading = false;
				})
				// 批改数据计算价格后
				let newList = this.jsonCopy(list.subjectMatter.filter(item => {
					return item.operation == 'ADD' || item.operation == 'EDIT' || item.operation == 'REMOVE' || item.operation == 'REPLACE'
				}))
				for (var i = 0; i < plist.length; i++) {
					for (var j = 0; j < newList.length; j++) {
						if ((plist[i].no == newList[j].no) && newList[j].operation == "EDIT") {
							this.$set(plist,i,{
								...newList[j],
								remark: '编辑',
								insuranceStatusName: '编辑',
							});
							newList.splice(j, 1)
						} else if ((plist[i].no == newList[j].previousNo) && newList[j].operation == 'ADD') {
							plist[i] = newList[j];
							plist[i].remark = '新增';
						} else if ((plist[i].no == newList[j].no) && newList[j].operation == "REPLACE") {
							plist[i].operation = 'REPLACED'
							plist[i].remark = '被替换';
							plist[i].premium = '-';
							plist.splice(i + 1, 0, {
								...newList[j],
								operation: 'REPLACE',
								remark: '替换',
								insuranceStatusName: '替换',
								effectiveStatusDesc: '',
								effectiveStatus: ''
							})
							newList.splice(j, 1)
						}
					}
				}
				this.loading = false;
				newData = plist.concat(newList)
			} else {
				this.loading = false;
				newData = res.subjectMatter;
			}
			this.orderDataRst = this.jsonCopy(newData); // 原始数据 搜索用
			this.pageinfo.total = this.orderDataRst.length;
			this.orderData = this.currentChangePage(this.pageinfo.size,this.pageinfo.page);
			this.getTree();
		},
		getSatus(){
			setTimeout(()=>{
				this.$axios.get('/broker/insurance/endorse/detailByEndorseNo', { endorseNo: this.endorseNo }).then(res=>{
					this.endorseStatus = res.endorseStatus;
					if(res.endorseStatus =='CONFIRMED'||res.endorseStatus =='FINISHED'){
						// 调获取订单号接口
						this.$axios.post('/broker/order/list.json',{
							bizId:'INDUSTRY_ENTERPRISE',
							applicationNo: this.info.applicationNo,
							count:10,
							page:1
						}).then(async res=>{
							await this.stopRecord({
								session_key:sessionStorage.track_session_key,
								policy_id: res[0].endorseNo
							});
							this.confirmLoading = false;
							clearInterval(this.timer)
							window.location.href=`/common.html#/payCCIC?orderNo=${res[0].orderNo}&productCode=${this.info.productCode}`
						}).catch(err=>{
							this.confirmLoading = false;
							clearInterval(this.timer)
						})
					} else if(res.endorseStatus =='REVIEWED_REJECTED'||res.endorseStatus =='REJECTED'){
						this.confirmLoading = false;
						this.info.remark = res.remark;
						clearInterval(this.timer)
					}
				}).catch(err=>{
					this.confirmLoading = false;
					clearInterval(this.timer)
				})
          	}, 0)
		},
		checkPerson(idCard) {
			let index = this.orderData.findIndex(item => {
				return item.operation != 'REMOVE' && item.operation != 'REPLACED' && item.idCard == idCard
			})
			if (index > -1) {
				this.alert('身份证号与列表人员重复，请核对身份证号。')
				return false
			} else {
				return true
			}
		},
		// 添加
		add() {
			this.addShow = true;
			this.addForm = {};
			this.$refs.addForm.resetFields();
		},
		batch() {
			if (this.isReset) {
				this.$router.push('/companyGroupEmployerDadi/edit-batch/' + this.id + '?reset=NEW')
			} else {
				this.$router.push('/companyGroupEmployerDadi/edit-batch/' + this.id)
			}
		},
		// 确定
		confirmAdd() {
			this.$refs.addForm.validate(valid => {
				if (valid && this.checkPerson(this.addForm.idCard)) {
					this.getPremium({
						...this.addForm,
						operation: 'ADD'
					}).then(res => {
						if (res) {
							this.orderDataRst.unshift({
								...res
							});
							this.orderData = this.currentChangePage(this.pageinfo.size,this.pageinfo.page);
							this.number = '';
							this.check = '1';
							this.pageinfo.total = this.orderDataRst.length;
							this.addShow = false;
						}
					})
				}
			})
		},
		// 打开修改名字
		openEdit(row) {
			this.editShow = true;
			this.editForm = this.jsonCopy(row);
			this.$refs.editForm.resetFields();
		},
		// 确定修改
		confirmEdit() {
			this.$refs.editForm.validate(valid => {
				if (valid) {
					// 原始数据修改
					let initIndex = this.orderDataRst.findIndex(item => {
						return this.editForm.id == item.id
					})
					this.orderDataRst.splice(initIndex, 1, {
						...this.editForm,
						operation: 'EDIT',
						remark: '编辑',
						insuranceStatusName: '编辑',
						refIdCard: this.editForm.idCard,
						refId: this.editForm.id
					});
					this.pageinfo.total = this.orderDataRst.length;
					this.orderData = this.currentChangePage(this.pageinfo.size,this.pageinfo.page);
					this.number = ''
					this.pageinfo.total = this.orderDataRst.length;
					this.editShow = false;
				}
			})
		},
		// 撤回
		recall(row, index) {
			let text = ''
			if (row.operation == 'EDIT') {
				text = '确定撤回编辑人员姓名？'
			} else if (row.operation == 'REMOVE') {
				// 退保
				text = '确定撤回退保人员？'
			} else if (row.operation == 'REPLACE') {
				// 替换新增
				text = '确定撤回替换人员？'
			}
			this.confirm(text, () => {
				// 查找原始保单数据有没有当前选中的数据
				let originalIndex = this.originalList.findIndex(item => {
					return item.id == row.refId
				})
				if (row.operation == 'REPLACE') {
					// 原始数据中查不到的话 不替换
					if(originalIndex>-1){
						this.orderData.splice(index - 1, 1, this.originalList[originalIndex])
					}
					this.orderData.splice(index, 1)
					this.orderDataRst.forEach((item,inx)=>{
						if(item.id==row.id&&item.operation == 'REPLACE'){
							this.orderDataRst.splice(inx, 1)
							this.orderDataRst.splice(inx-1, 1, this.originalList[originalIndex])
						}
					})
				} else if(row.operation == 'EDIT'){
					this.orderDataRst.forEach((item,inx)=>{
						if(item.refId==row.refId&&item.operation == 'EDIT'){
							this.orderDataRst.splice(inx, 1, this.originalList[originalIndex])
						}
					})
					this.orderData.splice(index, 1, this.originalList[originalIndex])
				}
				this.getPremium();
			})
		},
		// 删除新增
		delList(row,index) {
			this.$Modal.confirm({
				title: '确定删除新增人员？',
				okText:'取消',
				cancelText:'确认',
				onOk: () => {
					
				},
				onCancel: () => {
					this.orderDataRst.forEach((item,inx)=>{
						if(item.idCard==row.idCard&&item.operation == 'ADD'){
							this.orderDataRst.splice(inx, 1)
						}
					})
					this.orderData.splice(index, 1)
					this.getPremium()
				}
			});
		},
		// 退保
		refund(row, index) {
			this.confirm('确定该名员工退出保障计划吗？确认后，将把员工状态临时置为已失效，“提交信息”后才最终生效', () => {
				this.getPremium({
					...row,
					operation: 'REMOVE',
				}).then(res => {
					this.orderData.splice(index, 1, {
						...res,
						operation: 'REMOVE',
						insuranceStatusName: '退出'
					});
				})
			})
		},
		// 价格格式化，最多2位小数
		numFormat(num) {
			return Number(num.toString().match(/^\d+(?:\.\d{0,2})?/))
		},
		// 打开替换
		openRelace(row) {
			this.replaceShow = true;
			this.replaceData = row;
			this.replaceForm = {};
			this.$refs.replaceForm.resetFields();
		},
		// 确定替换
		confirmReplace() {
			this.$refs.replaceForm.validate(valid => {
				if (valid && this.checkPerson(this.replaceForm.idCard)) {
					// 替换人
					this.replaceLoading = true
					this.getPremium({
						...this.replaceForm,
						operation: 'REPLACE',
						refIdCard: this.replaceData.idCard,
						no: this.replaceData.no,
						scheme: this.replaceData.scheme,
						schemeName: this.replaceData.schemeName,
						refId: this.replaceData.id,
						premium: this.replaceData.premium
					}).then(res => {
						if (!res) return
						// 原始数据赋值
						let initIndex = this.orderDataRst.findIndex(item => {
							return item.id == this.replaceData.id
						})
						let effectiveDateEnd = (Date.parse(res.effectiveDateStart) - 3600 * 1000 * 24) < Date.parse(this.orderDataRst[initIndex].effectiveDateStart)
							? this.orderDataRst[initIndex].effectiveDateStart
							: this.formatDate((Date.parse(res.effectiveDateStart) - 3600 * 1000 * 24))
						this.orderDataRst.splice(initIndex + 1, 0, {
							...res,
							operation: 'REPLACE',
							remark: '替换',
							insuranceStatusName: '替换'
						})
						this.orderDataRst.splice(initIndex, 1, {
							...this.orderDataRst[initIndex],
							effectiveDateEnd: effectiveDateEnd,
							premium: '-',
							operation: 'REPLACED',
							remark: '被替换'
						})
						this.pageinfo.total = this.orderDataRst.length;
						this.orderData = this.currentChangePage(this.pageinfo.size,this.pageinfo.page);
						this.number = '';
						this.replaceShow = false;
						this.replaceLoading = false
						this.pageinfo.total = this.orderDataRst.length;
					}).catch(err=>{
						this.replaceLoading = false
					});
				}
			})
		},
		// 提交
		sub() {
			this.confirm('确定提交信息？', () => {
				let list = this.jsonCopy(this.orderDataRst.filter(item => {
					return item.operation == 'ADD' || item.operation == 'EDIT' || item.operation == 'REMOVE' || item.operation == 'REPLACE'
				}))
				this.$axios.post('/broker/insurance/endorse/apply.json.all.dst', {
					insurancePolicyId: this.id,
					subjectMatter: list
				}).then(res => {
					this.confirmForm = res.data;
					this.confirmShow = true;
				})
			})
		},
		// 确认跳转
		confirmSub() {
			if(this.correctUrlList.length==0){
				this.alert('请上传批改单！')
				return
			}
			if(this.confirmLoading){
				return
			}
			this.confirmLoading = true;
			let list = this.jsonCopy(this.confirmForm.subjectMatter.filter(item => {
				return item.operation == 'ADD' || item.operation == 'EDIT' || item.operation == 'REMOVE' || item.operation == 'REPLACE'
			}))
			let data = {
				insurancePolicyId: this.confirmForm.insurancePolicyId,
				subjectMatter: list,
				premium: this.confirmForm.premium
			}
			if(this.correctUrlList.length>0){
				data.subjectMatterUrls = this.correctUrlList.join(',')
			}
			this.$axios.post('/broker/insurance/endorse/confirm.json',data).then(async res => {
				if(res&&res.charAt(0)=='E'){
					this.confirmShow = false;
					this.endorseNo = res
					this.getSatus()
					this.timer = setInterval(() => {
						this.getSatus()
					}, 5000)
				} else {
					// 订单号
					this.$axios.post('/broker/order/detail',{
						orderNo: res
					}).then(async respon=>{
						// 回溯 停止录制
						await this.stopRecord({
							session_key:sessionStorage.track_session_key,
							policy_id: respon.endorseNo
						});
						this.confirmLoading = false;
						window.location.href=`/common.html#/payCCIC?orderNo=${res}&productCode=${this.info.productCode}`
					})
				}
			}).catch(err=>{
				this.confirmLoading = false;
			});
		},
		// 非高空选择工种
		jobTypeChange(val) {
			let jobItem = this.jobList.find(item => {
				return item.jobTypeCode == val
			})
			if (jobItem) {
				this.caseList = jobItem.list;
			}
		},
		jobSelectChange(val){
			let jobItem = this.radioList.find(item => {
				return item.jobTypeCode == val.value
			})
			this.$set(this.addForm, 'jobTypeCode', val.value)
			this.$set(this.addForm, 'jobTypeName', val.label)
			this.$set(this.addForm, 'riskCategory', jobItem.riskCategory)
			this.$set(this.addForm, 'riskCategoryName', jobItem.riskCategoryName) 
			this.$set(this.addForm,'quoteRiskCategory',jobItem.riskCategory)
			this.$set(this.addForm, 'scheme', ''); // 方案重置
			this.getCaseList('addForm');
			console.log('this.addForm',this.addForm)
		},
		// 高空选择工种
		jobChange(val, key) {
			if (!val.value) return
			this.$set(this[key], 'jobTypeCode', val.value)
			this.$set(this[key], 'jobTypeName', val.label)
			this.$set(this[key], 'riskCategory', val.riskCategory)
			this.$set(this[key], 'riskCategoryName', val.riskCategoryName)
			this.$set(this[key],'quoteRiskCategory',val.riskCategory)
			if (key == 'addForm'&&val.value) {
				this.$set(this.addForm, 'scheme', ''); // 方案重置
				this.getCaseList('addForm')
			}
		},
		// 选择方案
		caseChange(row) {
			let newindex = this.caseListAll.findIndex((val) => {
				return val.scheme == row;
			});
			if (newindex >= 0) {
				this.addForm.schemeName = this.caseListAll[newindex].value
			}
		},
		// 下载模板
		download() {
			let list = this.jsonCopy(this.confirmForm.subjectMatter.filter(item => {
				return item.operation == 'ADD' || item.operation == 'EDIT' || item.operation == 'REMOVE' || item.operation == 'REPLACE'|| item.operation == 'REPLACED'
			}))
			this.$axios.post('/broker/export/exportEndorse.json', {
				cntrNo: this.info.cntrNo,
				insurancePolicyId: this.id,
				subjectMatter: list,
				bizId: 'INDUSTRY_ENTERPRISE',
				productCode: this.info.productCode,
				subjectName:this.info.applicantName
			}).then(res => {
				if (res) {
					this.getBlob(res).then((blob) => {
						this.saveAs(blob, '保险合同变更申请书')
					})
				}
			})
		},
		getBlob(url) {
			return new Promise((resolve) => {
				const xhr = new XMLHttpRequest()
				xhr.open('GET', url, true)
				xhr.responseType = 'blob'
				xhr.onload = () => {
					if (xhr.status === 200) {
						resolve(xhr.response)
					}
				}
				xhr.send()
			})
		},
		// 自定义下载文件名称
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			} else {
				const link = document.createElement('a')
				const body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob) // 创建对象url
				link.download = filename

				// fix Firefox
				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)

				window.URL.revokeObjectURL(link.href) // 通过调用 URL.createObjectURL() 创建的 URL 对象
			}
		},
		/*上传成功后获取数据*/
		uploadSuccess(res) {
			if (this.correctUrlList.length < 5) {
				this.correctUrlList.push(res.url)
			} else {
				this.alert('最多上传5张批改单！')
			}
		},
		del(index) {
			this.correctUrlList.splice(index, 1)
		},
		// 保费计算
		getPremium(form) {
			let list = this.orderDataRst.filter(item => {
				return item.operation == 'ADD' || item.operation == 'REMOVE' || item.operation == 'REPLACE'
			})
			if (form) list.push(form)
			if (list.length == 0) return
			return this.$axios.post('/broker/insurance/endorse/apply.json.all.dst', {
				insurancePolicyId: this.id,
				subjectMatter: list
			}).then(result => {
				this.replaceLoading = false
				if (result.code !== 10000000) {
					this.alert(result.msg)
					return
				}
				let res = result.data.subjectMatter
				this.orderDataRst.forEach((item, index) => {
					let addItem = res.find(resItem => {
						return item.operation == 'ADD' && item.idCard == resItem.idCard
					})
					if (addItem) {
						this.orderDataRst.splice(index, 1, {
							...item,
							...addItem
						})
					}
				})
				if (form) {
					let item = res.find(item => {
						return item.idCard == form.idCard
					})
					return item
				}
				this.pageinfo.total = this.orderDataRst.length;
				this.orderData = this.currentChangePage(this.pageinfo.size,this.pageinfo.page);
			})
		}
	}
}
</script>
<style scoped lang="less">
.main {
	margin-top: 24px;
	min-height: 100vh;
}
.mb0 {
	margin-bottom: 0;
}

.edit-warning {
	font-size: 16px;
	color: red;
	margin-right: 20px;
}

.errorMsg {
	font-size: 16px;
	color: red;
	float: right;
	line-height: 32px;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/Edit.vue